module.exports = __webpack_public_path__ + "img/no-documents.b4aad200.svg";